import { Link } from "react-router-dom";
import type { Live } from "@/types/live";
import { getAnchorById } from "@/mocks/anchors";
import { formatViewers } from "@/utils/format";

interface LiveCardProps {
  live: Live;
  size?: "default" | "compact";
}

export default function LiveCard({ live, size = "default" }: LiveCardProps) {
  const anchor = getAnchorById(live.anchorId);
  const isLive = live.status === "live";

  return (
    <Link
      to={`/live/${live.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className={`relative w-full overflow-hidden ${size === "compact" ? "h-40" : "h-44"}`}>
        <img
          src={live.cover}
          alt={`${live.title} - 蜜梨直播`}
          title={`${live.title} 蜜梨直播`}
          className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
        />
        <div className="absolute left-2 top-2 flex items-center gap-1">
          <span
            className={`flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-semibold ${
              isLive ? "bg-primary-500 text-background-50" : "bg-foreground-800/80 text-background-50"
            }`}
          >
            {isLive && <span className="h-1.5 w-1.5 rounded-full bg-background-50" />}
            {isLive ? "直播中" : "已结束"}
          </span>
        </div>
        <div className="absolute bottom-2 right-2 flex items-center gap-1 rounded-full bg-foreground-950/70 px-2 py-0.5 text-xs text-background-50">
          <i className="ri-eye-line text-sm" />
          {formatViewers(live.viewers)}
        </div>
      </div>

      <div className="p-3">
        <h3 className="line-clamp-2 min-h-[40px] text-sm font-semibold leading-5 text-foreground-950 transition-colors group-hover:text-primary-600">
          {live.title}
        </h3>
        <div className="mt-3 flex items-center gap-2">
          <span className="h-7 w-7 shrink-0 overflow-hidden rounded-full bg-secondary-200">
            <img
              src={anchor?.avatar}
              alt={`${anchor?.name} 头像`}
              className="h-full w-full object-cover object-top"
            />
          </span>
          <span className="truncate text-xs text-foreground-600">{anchor?.name}</span>
          <span className="ml-auto flex shrink-0 items-center gap-1 text-xs text-foreground-400">
            <i className="ri-chat-3-line text-sm" />
            {live.danmaku}
          </span>
        </div>
      </div>
    </Link>
  );
}